<template>
  <div :class="['pricing-card', { 'pricing-card--most-popular': mostPopular }]">
    <span v-if="mostPopular" class="pricing-card__badge">Most Popular</span>
    <div>
      <h2 class="h5">{{ title }}</h2>
    <p class="plan-description p--sm ">
      
      {{ planDescription }}
    </p>
  </div>

  <div class="pricing-card_priceHolder">
    <p
      :class="[
        { planDisabled: isDisabled },
        'p--sm',
        'pricing-card__price',
      ]"
    >
      <span v-if="!isDisabled" class="pricing-card__currency">{{
        currencySymbol
      }}</span>
      <span v-if="customPricing" class="p--sm mb-8"
        >Custom pricing available</span
      >
      <span v-else-if="isDisabled" class="p--sm mb-2">
        You've selected more contacts than this plan allows</span
      >
      <span v-else-if="perFreq === 'year'" class="h3 pricing-card__amount">
        <span>{{ (price / 12).toFixed(2).split('.')[0] }}</span>
        <span style="font-size: 24px;">.{{ (price / 12).toFixed(2).split('.')[1] }}</span>
      </span>
      <span v-else class="h3 pricing-card__amount">
        {{ price.toFixed(0) }}
      </span>
    </p>
    <div class="p--xs" v-if="price === 0 || isDisabled">
      &nbsp;
    </div>
    <div class="p--xs" v-else-if="perFreq === 'year'">
      Per month, billed annually
    </div>
    <div class="p--xs" v-else>Per month, billed monthly</div>
  </div>
    <form v-if="customPricing" action="/contactus">
      <button class="btn btn--primary btn--sm pricing-card__btn">
        Contact us
      </button>
    </form>

    <button v-else class="btn btn--primary btn--sm pricing-card__btn" :disabled="isDisabled" v-on:click="goToRegister">
      Create free account
    </button>

    <ul class="pricing-card__limitations" v-if="limitations.length > 0">
      <li
        class="pricing-card__limitation"
        v-for="(limitation, index) in limitations"
        :limitation="limitation"
        :key="limitation.id"
        :index="index"
      >
        <p class="p--sm">
          <strong>{{ limitation }}</strong>
        </p>
      </li>
    </ul>

    <hr class="mt-6 mb-6 content-breaker" v-if="limitations.length > 0" />  

    
    <div class="pricing-card__features">

      <p v-if="previousPlanText" class="mb-4 p--sm pricing-card__previous-plan">
        <strong>{{ previousPlanText }}</strong>
      </p>

      <ul>
        <li
          class="pricing-card__feature"
          v-for="(feature, index) in features"
          :feature="feature"
          :key="feature.id"
          :index="index"
        >
          <p class="mb-1 p--sm">{{ feature }}</p>
        </li>
      </ul>
      
    </div>

    <div class="pricing-card__view-all-features p--sm" v-on:click="trackViewFeatures">View all features</div>
  </div>
</template>

<script>
import TrackingHelpers from "@/functions/tracking";
import { gtmRegistrationStart, gtmTracking } from "@/functions/gtm-tracking";

export default {
  name: "PricingCard",
  props: [
    "title",
    "plan-description",
    "features",
    "limitations",
    "price",
    "isDisabled",
    "customPricing",
    "currencySymbol",
    "perFreq",
    "previousPlanText",
    "mostPopular",
  ],
  setup()
  {
    return { TrackingHelpers }
  },
  data() {
    return {
      planFeatures: this.features,
      planLimitations: this.limitations,
    };
  },
  methods: {
    goToRegister() {
      gtmRegistrationStart("CTA Click", "Create free account", "Pricing")();
      TrackingHelpers.linkToApp("register?welcome=true");
    },
    trackViewFeatures() {
      gtmTracking("CTA Click", "View all features", "Pricing")();
      this.$emit("openComparisonModal");
    },
  },
};
</script>
